// extracted by mini-css-extract-plugin
export var dashes = "m_bl";
export var description = "m_L";
export var marginIcon = "m_K";
export var right = "m_bn";
export var screenshot = "m_T";
export var slowJiggle = "m_bm";
export var tool = "m_bk";
export var toolBody = "m_bj";
export var tools = "m_bd";